import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getMyTasksApi } from "../../../app/api";
import { createPortal } from "react-dom";
import TaskSubtasks from "../../../components/Tasks/TaskSubtasks";

const IMAGE_BASE_URL = "https://demouptask.visiontrek.io";

export default function UsersDetailMy() {



  const [expandedTasks, setExpandedTasks] = useState([]);

  const toggleDescription = (taskId) => {
    setExpandedTasks((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId]
    );
  };


  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    try {
      const res = await getMyTasksApi();

      if (res.success) {
        setTasks(res.data);
      } else {
        toast.error("Failed to load tasks");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const columns = [
    { title: "New Task", key: "TODO", border: "border-t-blue-500", bg: "bg-[#050B1A]" },
    { title: "In Progress", key: "IN_PROGRESS", border: "border-t-cyan-400", bg: "bg-[#032432]" },
    { title: "Pending", key: "PENDING", border: "border-t-[#fb8110]", bg: "bg-[#1A0D02]" },
    { title: "Complete", key: "DONE", border: "border-t-[#28B07E]", bg: "bg-[#072319]" },
  ];



  const [selectedTask, setSelectedTask] = useState(null);

  return (
    <div className="min-h-screen bg-[#1b153f] p-8 md:mt-24 rounded-[20px]">

      <div className="absolute top-20 left-20 w-72 h-72 bg-white/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>
      <div className="absolute bottom-10 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>

      <h2 className="text-2xl font-semibold text-white mb-6">
        My Task Board
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

        {columns.map((col) => {
          const filtered = tasks.filter((task) => task.status === col.key);

          return (
            <div
              key={col.key}
              className={`rounded-2xl border-t-4 ${col.border} ${col.bg} shadow-xl flex flex-col h-[600px]`}
            >
              <div className="p-4">
                <h3 className="text-white font-semibold">{col.title}</h3>
              </div>

              <div className="flex-1 overflow-y-auto px-4 pb-4 space-y-4">

                {filtered.length === 0 ? (
                  <p className="text-gray-400 text-sm">No tasks</p>
                ) : (
                  filtered.map((task) => (
                    <div
                      key={task.id}
                      className=" relative rounded-xl p-4 bg-[#282B44] border border-[#2c3a4f] shadow-md hover:bg-[#243244] transition-all duration-300"
                    >
                      {/* Title */}
                      <h4 className="text-white font-semibold text-sm">
                        {task.title}
                      </h4>


                      {/* Description */}
                      {/* <p className="text-gray-400 text-xs mt-2 line-clamp-2">
                        {task.description}
                      </p> */}




                      <div className="mt-2">
                        <p
                          className={`text-gray-400 text-xs transition-all duration-300 ${expandedTasks.includes(task.id) ? "" : "line-clamp-2"
                            }`}
                        >
                          {task.description}
                        </p>

                        {task.description && task.description.length > 60 && (
                          <button
                            onClick={() => toggleDescription(task.id)}
                            className="text-cyan-400 text-[10px] mt-1 hover:underline"
                          >
                            {expandedTasks.includes(task.id) ? "Show Less" : "Show More"}
                          </button>
                        )}
                      </div>





                      <button
                        onClick={() => setSelectedTask(task)}
                        className="absolute top-3 right-3 bg-purple-500/20 text-purple-300 text-xs px-3 py-1 rounded-full border border-purple-400/30 hover:bg-purple-500/30 transition"
                      >
                        Subtasks
                      </button>


                      {/* Dates */}
                      <div className="flex justify-between text-[10px] text-gray-400 mt-3">
                        <div>
                          <p>Start</p>
                          <p className="text-gray-300">
                            {task.created_at
                              ? task.created_at.split(" ")[0]
                              : "--"}
                          </p>
                        </div>

                        <div>
                          <p>End</p>
                          <p className="text-gray-300">
                            {task.due_date
                              ? task.due_date.split(" ")[0]
                              : "--"}
                          </p>
                        </div>
                      </div>

                      {/* Progress */}
                      <div className="h-1 bg-gray-700 rounded-full mt-3">
                        <div
                          className="h-1 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full"
                          style={{
                            width:
                              task.status === "DONE"
                                ? "100%"
                                : task.completion_percent
                                  ? `${task.completion_percent}%`
                                  : "40%",
                          }}
                        />
                      </div>

                      {/* Bottom */}
                      <div className="flex items-center justify-between mt-3">

                        {/* Profile */}
                        <div className="flex items-center gap-2">
                          {task.creator_profile_pic ? (
                            <img
                              src={`${IMAGE_BASE_URL}${task.creator_profile_pic}`}
                              alt={task.creator}
                              className="w-7 h-7 rounded-full object-cover border border-white/20"
                            />
                          ) : (
                            <div className="w-7 h-7 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
                              {task.creator?.charAt(0)}
                            </div>
                          )}

                          <span className="text-xs text-gray-300">
                            {task.creator}
                          </span>
                        </div>

                        {/* Status */}
                        <span
                          className={`text-[10px] px-2 py-1 rounded-full font-medium
                            ${task.status === "DONE"
                              ? "bg-green-500/20 text-green-400"
                              : task.status === "IN_PROGRESS"
                                ? "bg-cyan-500/20 text-cyan-400"
                                : task.status === "PENDING"
                                  ? "bg-orange-500/20 text-orange-400"
                                  : "bg-blue-500/20 text-blue-400"
                            }`}
                        >
                          {task.status}
                        </span>

                      </div>
                    </div>
                  ))
                )}

              </div>
            </div>
          );
        })}






      </div>

      {selectedTask && (
        <SubtaskModal
          task={selectedTask}
          onClose={() => setSelectedTask(null)}
        />
      )}

    </div>
  );
}


function SubtaskModal({ task, onClose }) {
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white w-[500px] max-w-[95%] p-6 rounded-xl shadow-2xl">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-semibold text-lg">
            Subtasks - {task.title}
          </h3>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Reuse your existing subtask component */}
        <TaskSubtasks taskId={task.id} />

      </div>
    </div>,
    document.body
  );
}